import { t } from 'i18next';

import { YupTest } from 'coreOld/types';

export const testRequiredSchema = (
  required: boolean,
  fieldLabel?: string,
  message?: string
): YupTest => [
  'required',
  message
    ? message
    : t('errorRequiredField', {
        field: fieldLabel,
      }),
  (value) => !required || Boolean(value),
];
